import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import classNames from 'classnames';
import i18n from '../../i18n';
import Button from '../Button';
import styles from './ListOccurrences.module.scss';
import { useTranslation } from 'next-i18next';

const ListOccurrences = ({ occurrences = [] }) => {
    const [occurrencesVisible, setOccurrencesVisible] = useState(3);
    const { t } = useTranslation();

    const showMoreButtonIsVisible = occurrences.length > occurrencesVisible;
    const nextOccurrencesCount = occurrencesVisible + 20;
    const willShowAllAfterClick = nextOccurrencesCount >= occurrences.length;

    return (
        <div className={styles['ListOccurrences']}>
            <h2 className={styles['ListOccurrences__Title']}>
                {t('EventPage.allDatesHeader')}
            </h2>

            <Occurrences
                showMoreButtonIsVisible={showMoreButtonIsVisible}
                items={occurrences.slice(0, occurrencesVisible)}
            />
            {showMoreButtonIsVisible && (
                <Button
                    type="tertiary"
                    icon="plus"
                    iconColor="pink"
                    iconDirection="left"
                    text={
                        willShowAllAfterClick
                            ? t('EventPage.allDatesMore')
                            : t('EventPage.moreDates')
                    }
                    modifiers={[styles['ListOccurrences__More']]}
                    onClick={() => setOccurrencesVisible(nextOccurrencesCount)}
                />
            )}
        </div>
    );
};

const Occurrences = ({ items, showMoreButtonIsVisible }) => (
    <table
        className={classNames(styles['ListOccurrences__List'], {
            [styles['ListOccurrences__List--NoButton']]:
                !showMoreButtonIsVisible,
        })}>
        <tbody className={styles['ListOccurrences__ListContent']}>
            <tr className="sr-only">
                <th scope="col">Date</th>
                <th scope="col">Time</th>
            </tr>
            {items.map((item, i) => (
                <tr key={i} className={styles['ListOccurrences__Row']}>
                    <td className={styles['ListOccurrences__RowItem']}>
                        {dayjs(item.date).format('D MMMM')}
                    </td>
                    {item?.startTime && item?.endTime && (
                        <td className={styles['ListOccurrences__RowItem']}>
                            {item.startTime.slice(0, 5)} –{' '}
                            {item.endTime.slice(0, 5)}
                        </td>
                    )}
                </tr>
            ))}
        </tbody>
    </table>
);

ListOccurrences.propTypes = {
    occurrences: PropTypes.array,
};

export default ListOccurrences;
